import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import {
    PublicRoutes, RoutesWithUserSession
} from "./routes";
import { createHashRouter, createBrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuth, selectSessionToken, selectUserSession, selectUserSessionState, setAuthStatus, setSession } from "../store/features/session/userSession";
import AuthAPI from "../api/endpoints/Auth";
import { useAppDispatch } from "../store/hooks";
import { selectIsInitStatus, setInitStatus } from "../store/features/appState";

const CreateRouterFunc = (
    process.env.REACT_APP_ROUTER_TYPE === "BROWSER" ?
        createBrowserRouter : createHashRouter
);

const publicAppRouter = CreateRouterFunc(PublicRoutes);
const sessionAppRouter = CreateRouterFunc(RoutesWithUserSession);
export const MainRouter = () => {
    const dispatch = useAppDispatch();
    const appInitialized = useSelector(selectIsInitStatus);
    const userToken = useSelector(selectSessionToken);
    const checkUserSession = async () => {
        if (!userToken) {
            dispatch(setInitStatus(true));
            return;
        }
        let userSession = null;
        try {
            userSession = await AuthAPI.getSession();
        } catch (e: any) {
            dispatch(setAuthStatus(false));
            dispatch(setSession(null));
        }
        dispatch(setInitStatus(true));
    };
    useEffect(() => {
        checkUserSession();
    }, [userToken]);
    const currentRouter = (
        userToken ?
            sessionAppRouter : publicAppRouter
    );
    if (appInitialized) {
        return (
            <>
                <RouterProvider router={currentRouter} />
            </>
        );
    }
    return null;
};

export default MainRouter;